<template>
  <div class="modal fade" :id="id" data-bs-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <form @submit.prevent="submitData" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{$t('access.card.assign_card')}}</h5> <!-- Changé le titre -->
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal" aria-label="Close">
              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"/>
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"/>
                </svg>
              </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText />

            <Select2
                :parent-id="'#'+id"
                containerClass="col-12 mb-5"
                :name="'assignee'+id"
                :multiple="false"
                :label="$t('access.card.assign_to')"
                labelClass="mb-3"
                selectClass="form-select form-select-solid"
                :isRequired="true"
                :placeholderText="$t('access.card.select_assignee_placeholder')"
                v-model="formData.assignable_id"
                :IsInputGroup="true"
                icon="bi bi-plus"
                :clickAddon="openCreateContactModal"
            >

              <optgroup :label="$t('access.card.users_group')">
                <option v-for="user in userWithoutAssigned" :key="user.id" :value="'user;'+user.id">
                  {{ user.fullname}}
                </option>
              </optgroup>


              <optgroup :label="$t('access.card.contacts_group')">
                <option v-for="contact in contactWithoutAssigned" :key="contact.id" :value="'contact;'+contact.id">
                  {{ contact.fullname }}
                </option>
              </optgroup>
            </Select2>

            <div class="form-group mt-5">
              <label class="form-label fs-6 text-black">{{ $t('absences.motif') }}</label>
              <textarea v-model="formData.object" class="form-control form-control-solid" rows="3"
              ></textarea>
            </div>

          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
            <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.assign" size="7px 30px" :is-loading="isLoading"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <CreateContactModal :id="'create_contact_modal'" @callback="getNewContactId" :parent-id="id" />
</template>

<script setup>
import {ref, defineProps, computed, onMounted, watch} from 'vue'
import {useStore} from "vuex";
import RequiredText from "@/components/RequiredText"
import Button from "@/components/Button.vue"
import Select2 from "@/components/Select2.vue";
import i18n from "@/plugins/i18n";
import CreateContactModal from "@/Modules/Access/views/Cards/components/CreateContactModal.vue";

const store = useStore()

const props = defineProps({
  form: {
    type: Object,
    default: {
      id: '',
      assignable_id: '',
      object: ''
    }
  },
  id: {
    type: String,
    required: true
  },
})

const emits = defineEmits(['load'])

const formData = ref({...props.form})


const isLoading = ref(false)

const contacts = computed(() => store.getters["contacts/getContacts"] || [])
const contactWithoutAssigned = computed(() => {
  return contacts.value.filter(contact => {
    return !getAssignedCards.value.some(a => a.id === contact.id);
  });
});
const users = computed(() => store.getters["user/getUsers"] || [])
const userWithoutAssigned = computed(() => {
  return users.value.filter(user => {
    return !getAssignedCards.value.some(a => a.id === user.id);
  });
});
const getAssignedCards = computed(() => store.getters["cards/getAssignedCards"] || [])

watch(() => props.form, (value) => {
  formData.value = {...props.form};
}, { deep: true });

function getNewContactId(newContactId) {
  formData.value.assignable_id = 'contact;'+newContactId;
}
function openCreateContactModal() {
  $('#'+props.id).modal('toggle');
  $('#create_contact_modal').modal('toggle');
}
function submitData(){
  isLoading.value = true;
  let message = 'notification.card_assigned';

  const [type, id] = formData.value.assignable_id.split(';');

  store.dispatch('cards/assignCard', {
    card_id: props.form.id,
    assignable_id: id,
    assignable_type: type,
    object: formData.value.object
  })
      .then((response) => {
        loadAssignable()
        emits('load');
        isLoading.value = false;
        closeModal();
        resetForm();
        window.toastr['success'](i18n.global.t(message));
      })
      .catch(err => {
        isLoading.value = false;
        window.toastr['error'](i18n.global.t('notification.error_occurred'));
      });
}

function closeModal(){
  $('#'+props.id).modal('hide');
  resetForm();
}

function resetForm() {
  formData.value = {
    assignable_id: '',
    object: ''
  };
}

function loadAssignable() {
  store.dispatch('cards/loadAssignCard')
}

onMounted(() => {
  loadAssignable()
})
</script>